import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[var(--dough)] px-4"
    >
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-3 mb-8">
          <img src="/logo-emilios.jpg" alt="Emilio's Restaurant & Pizzeria" className="h-24 w-auto rounded-lg" />
          <div className="text-center">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--charcoal-soft)]">
              Staff sign-in
            </div>
          </div>
        </Link>

        <form
          onSubmit={onSubmit}
          className="bg-white border border-[var(--line)] rounded-2xl p-8 space-y-5"
          data-testid="admin-login-form"
        >
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-[var(--charcoal-soft)]">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-2 w-full px-4 py-3 rounded-lg border border-[var(--line)] focus:border-[var(--terracotta)] focus:outline-none bg-[var(--dough)]/40"
              placeholder="admin@emiliospizza.com"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-[var(--charcoal-soft)]">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-2 w-full px-4 py-3 rounded-lg border border-[var(--line)] focus:border-[var(--terracotta)] focus:outline-none bg-[var(--dough)]/40"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full bg-[var(--terracotta)] hover:bg-[var(--terracotta-hover)] text-white font-semibold transition-all disabled:opacity-60"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            Sign in
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/"
            data-testid="admin-back-home"
            className="text-sm text-[var(--charcoal-soft)] hover:text-[var(--terracotta)]"
          >
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  );
}
